import { NgClass } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { QuillEditorComponent } from 'ngx-quill'

import { Headline, ListItem, RepositoryModal, quillLinkHandler } from '../../shared'
import { HeadlinesComponent } from './headlines.component'

@Component({
    templateUrl: './headline.component.html',
    standalone: true,
    imports: [FormsModule, NgClass, WjInputModule, QuillEditorComponent, FaIconComponent],
})
export class HeadlineComponent extends RepositoryModal<Headline> implements OnInit {
    faQuestionCircle = faCircleQuestion

    isHeadline = true

    userList: ListItem<string>[] = []
    meetingsList: ListItem<string>[] = []
    ranksList: ListItem<number>[] = [new ListItem(1, '1'), new ListItem(2, '2'), new ListItem(3, '3'), new ListItem(4, '4')]

    editorModules = {
        toolbar: {
            container: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ header: [1, 2, 3, false] }],
                ['link'],
            ],
            handlers: { link: quillLinkHandler },
        },
        clipboard: {
            matchVisual: false,
        },
    }

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as HeadlinesComponent
        this.isHeadline = parentComponent.isHeadline()
        this.userList = parentComponent.allActiveUserList.filter(listItem => parentComponent.meeting()?.userIds.includes(listItem.value))
        this.meetingsList = parentComponent.meetings().map(meeting => new ListItem<string>(meeting.id, meeting.name))

        if (this.isAdding) {
            this.target.userId = this.services.authentication.userId()
            this.target.expirationDate = new Date().addDays(7)

            this.target.rank = 1

            const currentMeetingId = parentComponent.meetingId()
            this.meetingsList.forEach(meeting => {
                if (meeting.value === currentMeetingId) {
                    meeting.$checked = true
                }
            })
        } else {
            this.meetingsList.forEach(meeting => {
                if (this.target.meetingIds.includes(meeting.value)) {
                    meeting.$checked = true
                }
            })
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.name) {
            this.services.notification.warning('Name is required')
            return false
        }

        this.target.type = this.isHeadline ? 0 : 1
        this.target.meetingIds = this.meetingsList.filter(meeting => meeting.$checked).map(meeting => meeting.value)
        return true
    }
}
